import React from 'react';
import PropTypes from 'prop-types';
import { QuickSearch } from '@qualtrics/ui-react';
import { withRouter } from 'react-router-dom';
import pages from '../../../../pages';

function reduceDown(items) {
    return items.reduce((result, item) => {
        if (item.children) {
            result.push(...reduceDown(item.children));
        } else {
            result.push(item);
        }
        return result;
    }, []);
}
const items = reduceDown(pages);

function handleSearch(query) {
    return items
        .filter(item => new RegExp(query, 'i').test(item.title))
        .map(item => ({ label: item.title, value: item }));
}

const PageSearch = ({ history, onSelect }) => {
    const searchRef = React.useRef();
    React.useEffect(() => {
        searchRef.current.focus();
    }, []);

    function handleSelect(item) {
        history.push(item.value.path);
        // eslint-disable-next-line no-unused-expressions
        onSelect && onSelect(item.value);
    }

    return (
        <QuickSearch
            ref={searchRef}
            full
            placeholder="Search..."
            onSearch={handleSearch}
            onSelect={handleSelect}
        />
    );
};

PageSearch.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }),
    onSelect: PropTypes.func,
};

PageSearch.defaultProps = {
    history: undefined,
    onSelect: undefined,
};

export default withRouter(PageSearch);
